module.exports = __webpack_public_path__ + "img/axentiv_logo.aa4a70b2.png";